// Survey-only top block: back arrow + 1/5 progress.
// Source: docs/specs/sprint-3/stage-4-screens.md §5.10.

import { Progress } from '@/components/ui/progress';
import { ScreenHeader } from '@/components/layout/ScreenHeader';

export function StepHeader({
  step,
  title,
  onBack,
}: {
  step: 1 | 2 | 3 | 4 | 5;
  title: string;
  onBack: () => void;
}) {
  const percent = step * 20;
  // Сброс скролла на смену route обрабатывает глобальный <ScrollToTop> в App.tsx.

  return (
    <header className="flex-shrink-0">
      <ScreenHeader onBack={onBack} title="Анкета" />
      <div className="px-6 pb-4">
        <div className="mb-2 flex items-center justify-between text-xs text-muted-foreground">
          <span>Шаг {step} из 5</span>
          <span>{percent}%</span>
        </div>
        <Progress value={percent} className="h-1.5 bg-muted" />
        <h1 className="mt-4 text-hl-title font-bold leading-tight">{title}</h1>
      </div>
    </header>
  );
}
